import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KakoudataKbn = props => {
  return <Dropdown.Static kubunKey='kakoudata_kbn' {...props} />
}
